/* REB-243 — PDP urgency, trust & conversion mechanisms (M1)
 *
 * B7 badge-priority resolver + B1 scarcity line + B3 upgrade-chip reactivity.
 * Data comes from the [data-pdp-conversion] island in product-info-cro45.liquid.
 * Re-runs on the theme's existing `variant:changed` event
 * (event.detail.variant = full variant object).
 *
 * B5 (selling-fast) and B6 (best-price) are PLACEHOLDER HOOKS — they return null
 * until M4 wires them to the metafields the data service (M2) will populate.
 * To enable in M4: make bestPriceFor()/sellingFastFor() read the relevant
 * metafield values exposed on the island, returning {kind, text} or null.
 */
(function () {
  function init() {
    var island = document.querySelector("[data-pdp-conversion]");
    if (!island) return;

    var data;
    try {
      data = JSON.parse(island.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.variants) return;

    var byId = {};
    data.variants.forEach(function (v) {
      byId[v.id] = v;
    });

    var scarcitySlot = document.querySelector('[data-slot="scarcity"]');
    var badgeSlot = document.querySelector('[data-slot="urgency-badge"]');
    var chip = document.querySelector("[data-upgrade-chip]");

    function money(pennies) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(pennies, "£{{amount}}").replace(".00", "");
      }
      return "£" + Math.round(pennies / 100);
    }

    function gradeLabel(v) {
      return String(v.grade || v.option2 || "").replace(/ ?condition/i, "").trim();
    }

    // Condition quality rank (higher = better grade). 0 = unknown/unrankable.
    function gradeRank(v) {
      var g = String(v.grade || v.option2 || "").toLowerCase();
      if (g.indexOf("pristine") > -1) return 4;
      if (g.indexOf("excellent") > -1) return 3;
      if (g.indexOf("great") > -1) return 2;
      if (g.indexOf("good") > -1) return 1;
      return 0;
    }

    // ---- B1: genuine low-stock scarcity for this exact priced unit (variant) ----
    // Only fires on real finite stock (inventory tracked AND policy 'deny'):
    //   1 left      → "Last one at this price"   (critical)
    //   2–4 left    → "Final few at this price"  (low)
    //   5+ / untracked → nothing
    function scarcityFor(v) {
      if (!v || !v.available) return null;
      if (!v.inv_managed || v.inv_policy !== "deny") return null;
      var qty = v.inv_qty;
      if (typeof qty !== "number" || qty < 1 || qty >= 5) return null;

      var text, level;
      if (qty === 1) {
        text = "Last one at this price";
        level = "critical";
      } else {
        text = "Final few at this price";
        level = "low";
      }

      // honest grade-up hint: cheapest in-stock sibling that is a genuinely BETTER
      // condition (higher grade rank) AND costs more — so "+£X" is always truthful and
      // reachable by switching condition on this same product. A pricier *lower* grade
      // (e.g. Good > Great by price) is never called a "grade up".
      var curRank = gradeRank(v);
      var higher = data.variants.filter(function (s) {
        return (
          s.option1 === v.option1 &&
          s.available &&
          gradeRank(s) > curRank &&
          s.price > v.price
        );
      });
      if (higher.length) {
        var minUp = higher.reduce(function (m, s) {
          return s.price < m ? s.price : m;
        }, Infinity);
        text += " — next grade up is +" + money(minUp - v.price);
      }

      return { level: level, text: text };
    }

    // ---- B7 placeholder hooks (wired in M4) ----
    function bestPriceFor(/* v */) {
      return null; // B6 — reads custom.best_price_90d once M2 populates it
    }
    function sellingFastFor(/* v */) {
      return null; // B5 — reads custom.behaviour_stats once M2 populates it
    }

    function rareFindActive(v) {
      return !!document.querySelector(
        '.badge.variant-badge[data-vid="' + v.id + '"]'
      );
    }

    // ---- B7 resolver: scarcity owns slot #6; one badge owns the top-left slot ----
    function resolveSlots(v) {
      if (scarcitySlot) {
        var sc = scarcityFor(v);
        if (sc) {
          scarcitySlot.textContent = sc.text;
          scarcitySlot.setAttribute("data-level", sc.level);
          scarcitySlot.hidden = false;
        } else {
          scarcitySlot.hidden = true;
          scarcitySlot.removeAttribute("data-level");
        }
      }

      if (badgeSlot) {
        // Priority: rare find → best price → selling fast (show ONE).
        // Rare find lives in the top-right sticker; if it's active it
        // suppresses the top-left badge so urgency claims never stack.
        var badge = rareFindActive(v)
          ? null
          : bestPriceFor(v) || sellingFastFor(v);
        if (badge) {
          badgeSlot.textContent = badge.text;
          badgeSlot.setAttribute("data-kind", badge.kind);
          badgeSlot.hidden = false;
        } else {
          badgeSlot.hidden = true;
          badgeSlot.removeAttribute("data-kind");
        }
      }
    }

    // ---- B3: swap the upgrade chip to the like-for-like deal for this variant ----
    // Each source variant has its own pre-matched upgrade (same condition/colour, deep
    // link to that exact variant) so the £-delta shown always equals the landing price.
    function updateChip(v) {
      if (!chip) return;
      var map = data.upgradeByVariant || {};
      var u = v && map[v.id];
      if (!u || !(u.delta > 0) || u.delta > data.upgradeDeltaCap) {
        chip.hidden = true;
        return;
      }
      var capEl = chip.querySelector("[data-upgrade-cap]");
      if (capEl) capEl.textContent = u.cap || "Upgrade";
      var deltaEl = chip.querySelector("[data-upgrade-delta]");
      if (deltaEl) deltaEl.textContent = money(u.delta);
      if (u.url) chip.setAttribute("href", u.url);
      chip.hidden = false;
    }

    function update(v) {
      if (!v) return;
      resolveSlots(v);
      updateChip(v);
    }

    update(byId[data.selectedVariantId] || data.variants[0]);

    document.addEventListener("variant:changed", function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      // prefer our island record (carries inventory fields); fall back to event
      update(
        byId[v.id] || {
          id: v.id,
          option1: v.option1,
          option2: v.option2,
          grade: v.option2,
          price: v.price,
          available: v.available,
          inv_qty: null,
          inv_managed: null,
          inv_policy: null,
        }
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
